module.exports = __webpack_public_path__ + "img/logo.e11dbac9.png";